<div i18n *ngIf="((totalCount$ | async) ?? 0) > 0" class="results-text">
  Showing <span class="results-highlight">{{ showingFrom$ | async }}</span> to
  <span class="results-highlight">{{ showTo$ | async }}</span> of
  <span class="results-highlight">{{ totalCount$ | async }}</span>
  <span [ngPlural]="totalCount$ | async">
    <ng-template ngPluralCase="=1"> result</ng-template>
    <ng-template ngPluralCase="other"> results</ng-template>
  </span>
</div>
<div i18n class="no-results-text" *ngIf="((totalCount$ | async) ?? 0) === 0">No Results</div>
